module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-illustrations/reverse.svg?535afddc543d4c45cf4549aa58af2b4e";